export default __webpack_public_path__ + "static/media/xero-certified-advisor-logo-hires-RGB.85367771.jpg";